import { WorkerAvailabilityRequest } from 'api/user'

export const userKey = ['user']
export const searchUserKey = (keyword: string) => [...userKey, keyword]
export const workerAvailabilityKey = ({
  shiftId,
  workerIds,
}: WorkerAvailabilityRequest) => [
  ...userKey,
  'workerAvailability',
  shiftId,
  workerIds?.join('|'),
]
export const userProfileByIdKey = (userId: number) => [
  ...userKey,
  userId,
  'userProfile',
]
export const userW2I9FormKey = (userId: number) => [
  ...userKey,
  userId.toString(),
  'userW2I9Form',
]
export const userUnprocessedI9Forms = [...userKey, 'unprocessedI9Forms']
export const userWorkExperience = (userId) => [
  ...userKey,
  userId,
  'workExperience',
]
export const userW2Status = (userId) => [...userKey, userId, 'w2Status']
export const userEventLogsKey = (args: {
  userId: number
  startsAt: string
  endsAt: string
}) =>
  [...userKey, args.userId, 'eventLogs', args.startsAt, args.endsAt] as const
export const userExternalTrainingKey = (userId: number) =>
  [...userKey, userId, 'externalTraining'] as const
export const userPrescreenedPositionsKey = (args?: {
  userId?: number
  cursor?: string
  direction?: 'next' | 'previous'
  pageSize?: number
}) => [...userKey, args?.userId, 'prescreenedPositions', args] as const
